/**
 * @desc 企业搜索AutoComplete公共组件
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import { AutoComplete } from 'antd';
import { isArray } from '../../../utils/util';
import { debounce } from '../../../utils/debounce';
import { getCompany } from '../../../services/common';

export default class CompanyAutoComplete extends PureComponent {
    constructor(props) {
        super(props);
        this.name = ''; // 搜素值
        this.state = {
            hide: true,
            dataSource: [], // 字符串数组：存公司name
            companys: [] // 待选公司arr
        };
    }

    componentWillUnmount() {
        this.handleSearch.cancel();
    }

    /**
     * @desc 输入框change时触发
     */
    handleSearch = debounce((name) => {
        this.name = name;

        if (name) {
            this.queryCompany();
        } else {
            this.setState({
                dataSource: [],
                companys: []
            });
        }
    }, 500);

    /**
     * @desc 异步获取匹配信息
     * @param {String} name | this.name 输入的信息
     */
    queryCompany = () => {
        getCompany({ name: this.name }).then(companys => {
            if (companys && isArray(companys) && companys.length > 0) {
                const dataSource = [];
                companys.forEach(item => {
                    dataSource.push(item.name);
                });
                this.setState({
                    dataSource,
                    companys
                });
            } else {
                this.setState({
                    dataSource: [],
                    companys: []
                });
            }
        });
    };

    /**
     * @desc 选中匹配信息，回调该公司相关信息数据
     * @param {String} value 选中公司的name
     * @returns {Object} item 回调方法携带所选公司的信息
     */
    onSelect = value => {
        const { getCompanyInfo } = this.props;
        getCompanyInfo && getCompanyInfo(this.state.companys.find(d => d.name === value));
    };

    onBlur = () => {
        this.setState({ hide: !this.state.dataSource.length });
    };

    onFocus = () => {
        this.setState({ hide: false });
    };

    render() {
        const { hide, dataSource } = this.state;
        const { placeholder, ...other } = this.props;

        return (
            <AutoComplete
                {...other}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                dropdownClassName={hide ? 'hidden' : ''}
                dataSource={dataSource}
                onSelect={this.onSelect}
                onSearch={this.handleSearch}
                placeholder={placeholder || '如“300156”，神雾环保'}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/companyAutoComplete/CompanyAutoComplete.jsx